var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRoundBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.2,
    stroke: "white",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56475 8.22388L4.39406 11.3946C4.30753 11.4811 4.19876 11.5254 4.06775 11.5274C3.93675 11.5294 3.82598 11.4851 3.73544 11.3946C3.64489 11.304 3.59961 11.1942 3.59961 11.0652C3.59961 10.9362 3.64489 10.8265 3.73544 10.7359L6.90611 7.56524L3.73544 4.39455C3.6489 4.30802 3.60462 4.19925 3.60262 4.06824C3.60061 3.93724 3.64489 3.82647 3.73544 3.73593C3.82598 3.64537 3.93575 3.6001 4.06475 3.6001C4.19375 3.6001 4.30352 3.64537 4.39406 3.73593L7.56475 6.9066L10.7354 3.73593C10.822 3.64938 10.9307 3.60511 11.0617 3.60311C11.1927 3.6011 11.3035 3.64537 11.3941 3.73593C11.4846 3.82647 11.5299 3.93624 11.5299 4.06524C11.5299 4.19424 11.4846 4.30401 11.3941 4.39455L8.22339 7.56524L11.3941 10.7359C11.4806 10.8225 11.5249 10.9312 11.5269 11.0622C11.5289 11.1932 11.4846 11.304 11.3941 11.3946C11.3035 11.4851 11.1937 11.5304 11.0647 11.5304C10.9357 11.5304 10.826 11.4851 10.7354 11.3946L7.56475 8.22388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundBorder);
export default __webpack_public_path__ + "static/media/close-round-border.dba50ed99bdb57cf376d8b9ca54a34ff.svg";
export { ForwardRef as ReactComponent };